'use client'; 
import { useState } from 'react';
import styles from './styles.module.scss';

interface ISearchProps {
  onSearch: (query: string) => void;
}

const Search = (
  { onSearch }: ISearchProps
) => {
  const [query, setQuery] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(query);
  };

  return (
    <form className={styles.searchForm} onSubmit={handleSubmit}>
      <div className={styles.searchInput}>
        <span className={styles.searchIcon} aria-hidden="true" />
        <input 
          type="search" 
          value={query} 
          onChange={handleChange} 
          placeholder="Search Blogs"
          aria-label="Search Blogs"
        />
      </div>
      <button className={styles.visuallyHidden} type="submit">Search</button>
    </form>
  );
};

export default Search;
